import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import Modal from "react-bootstrap/Modal";
import PopUp from "../../components/popUp";

function Banner(props) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <div className="revolution_gcc p-100">
        <Container className="h-100">
          <Row className="h-100">
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="text-center order-2 order-md-1 mt-4 mt-md-0"
            >
              <StaticImage
                src="../../../images/locationgcc/game/creating-mobile-games.webp"
                alt="TekRevol"
                className="banner-image"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={843}
                height={841}
              />
            </Col>
            <Col
              xs={12}
              md={6}
              lg={6}
              xl={6}
              xxl={6}
              className="order-1 order-md-2"
            >
              <h2>Creating Exceptional Mobile Games in 2D and 3D Dimensions</h2>
              <p>
                TekRevol is one of the leading game development companies in UAE
                and GCC region. We have built several games over the years in 2D
                and 3D – no matter your requirements, we are aware of the latest
                trends and can help you develop the game you want. All the games
                we build perform as you wish them to and fascinate the audience
                as intended.
              </p>
              <p>
                Among many game development Dubai companies, TekRevol is among
                the top few companies that have built the top 2D and 3D mobile
                game apps, published on Google Play and Apple App Store. Our
                extensive process of developing a game involves measures that
                deal with each step carefully and deliver you the best – so you
                know what you get when you partner with TekRevol. We are a
                reliable game app development company UAE, and we know how to
                keep our clients pleased. All we need to know is your idea of
                the game and whether you think it would work perfectly. Our game
                experts will analyze and refine the idea and handle everything
                for you. Here is a glimpse of what you get when you work with
                us.
              </p>
              <button
                onClick={handleShow}
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Game App
              </button>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-popup"
      >
        <div className="modal_forms">
          <PopUp setShow={setShow} />
        </div>
      </Modal>
    </>
  );
}

export default Banner;
